import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import MSLALogo from 'components/MSLALogo';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '99vh',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loadingMessage: {
    fontWeight: '600',
    fontSize: '1rem',
    lineHeight: '2.5rem',
  },
  titleContainer: {
    textAlign: 'center',
    padding: '1.5rem',
    color: '#0f487e',
    fontFamily: 'Roboto Slab',
  },
}));

const SplashPage = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <div>
        <div>
          <MSLALogo className="loadingAnimation" height="200" />
        </div>
        <div className={classes.titleContainer}>
          <div className={classes.loadingMessage}>Loading....</div>
        </div>
      </div>
    </div>
  );
};

export default SplashPage;
